var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g(_vm._b({style:(_vm.style)},'span',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }